var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWoe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125.449,
    height: 127.045,
    viewBox: "0 0 125.449 127.045",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20290",
    "data-name": "Grupo 20290",
    transform: "translate(-127.275 -183.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Sustracci\\xF3n_4",
    "data-name": "Sustracci\\xF3n 4",
    d: "M92.879,118.87v-7.009a57.76,57.76,0,0,0,22.076-70.853,57.135,57.135,0,0,0-12.164-18.216,56.491,56.491,0,0,0-18.022-12.27,56.348,56.348,0,0,0-44.093,0,56.491,56.491,0,0,0-18.022,12.27,57.639,57.639,0,0,0,0,81.07,57.072,57.072,0,0,0,9.912,8v7.006A63.374,63.374,0,0,1,2.359,80.591,63.606,63.606,0,0,1,18.372,18.548a63.311,63.311,0,0,1,9.283-7.733A62.545,62.545,0,0,1,38.309,4.977a62.379,62.379,0,0,1,48.831,0,62.545,62.545,0,0,1,10.655,5.839,63.43,63.43,0,0,1,27.655,52.512,64.015,64.015,0,0,1-2.359,17.264A63.381,63.381,0,0,1,92.881,118.87Z",
    transform: "translate(127.275 183.139)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20289",
    "data-name": "Grupo 20289",
    transform: "translate(159.844 216.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20247",
    "data-name": "Grupo 20247",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27693",
    "data-name": "Trazado 27693",
    d: "M0,50.661V9.321a8.593,8.593,0,0,1,17.186,0v41.34A8.593,8.593,0,0,1,0,50.661",
    transform: "translate(0 -0.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27692",
    "data-name": "Trazado 27692",
    d: "M75.8,50.661V9.321a8.593,8.593,0,0,1,17.186,0v41.34a8.593,8.593,0,0,1-17.186,0",
    transform: "translate(-32.305 -0.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27694",
    "data-name": "Trazado 27694",
    d: "M46.237,83.3h0a8.593,8.593,0,0,1-8.593-8.592V64.888a8.593,8.593,0,0,1,17.185,0v9.819A8.593,8.593,0,0,1,46.237,83.3",
    transform: "translate(-16.045 -24.412)",
    fill: "#41b6e6"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27707",
    "data-name": "Trazado 27707",
    d: "M-.46-13.1-3.119,2.782H-8L-9.972-9.342-12.057,2.782h-4.767L-19.437-13.1h3.759L-14.1-.06-11.9-13.1h3.942L-5.892-.06-4.036-13.1Zm8.136-.39a6.624,6.624,0,0,1,5.283,2.177,9.076,9.076,0,0,1,1.891,6.142A10.674,10.674,0,0,1,13.99-.7a6.408,6.408,0,0,1-2.475,2.876,7.165,7.165,0,0,1-3.839,1,7.17,7.17,0,0,1-3.827-.985A6.37,6.37,0,0,1,1.385-.667a10.716,10.716,0,0,1-.859-4.5,10.613,10.613,0,0,1,.859-4.446,6.431,6.431,0,0,1,2.464-2.876A7.106,7.106,0,0,1,7.676-13.49Zm0,2.75A2.628,2.628,0,0,0,5.258-9.422a8.614,8.614,0,0,0-.791,4.251,8.579,8.579,0,0,0,.8,4.263A2.63,2.63,0,0,0,7.676.422,2.649,2.649,0,0,0,10.117-.9a8.676,8.676,0,0,0,.791-4.274,8.5,8.5,0,0,0-.8-4.263A2.66,2.66,0,0,0,7.676-10.74ZM26.836-13.1l-.39,2.681H20.854v3.8h4.882v2.636H20.854V.078h5.982v2.7H17.1V-13.1Z",
    transform: "translate(185.99 307.012)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoe);
export default __webpack_public_path__ + "static/media/woe.5d7b5c40be183f0f892d566d128f4ba0.svg";
export { ForwardRef as ReactComponent };